import { Box, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledFilterContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'expanded',
})<{ expanded?: boolean }>(({ theme, expanded }) => ({
  maxHeight: 800,
  overflowY: 'auto',
  margin: theme.spacing(3, 2),
  padding: expanded ? theme.spacing(2, 2) : theme.spacing(0.5, 2),
  borderRadius: '14px',
  backgroundColor: theme.palette.secondary.main,
}));

export const StyledCustomIconButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'highlighted',
})<{ highlighted?: boolean }>(({ theme, highlighted }) => ({
  color: highlighted ? theme.palette.getContrastText(theme.palette.highlightColor.main) : theme.palette.primary.main,
  border: '1px solid',
  borderColor: highlighted
    ? theme.palette.getContrastText(theme.palette.highlightColor.main)
    : theme.palette.primary.main,
  borderRadius: '50%',
  width: 24,
  height: 24,
  minWidth: 0,
  padding: 0,
}));

export const StyledOptionsBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'checked',
})<{ checked?: boolean }>(({ theme, checked }) => ({
  border: '1px solid',
  borderColor: theme.palette.secondary.main,
  padding: theme.spacing(0.5, 2, 0.5, 0.5),
  borderRadius: '10px',
  backgroundColor: checked ? theme.palette.highlightColor.main : theme.palette.common.white,
}));
